<template>
  <!--劳动合同-->
  <div class="labor-tpl">
    <form>
      <h1>保密协议</h1>
      <p class="l3">
        甲方（员工）：<input class="default" name="companyName" type="text" v-model="form.companyName">
      </p>
      <p class="l3">
        乙方（企业）：<input class="default" name="laborName" type="text" v-model="form.laborName">
      </p>
      　
      <p>
        鉴于甲方在乙方任职，并获得乙方支付的相应报酬，双方当事人就甲方在任职期间及离职以后保守乙方商业秘密的有关事项，订定下列条款共同遵守：
      </p>
      <p>
        第一条
        双方确认，甲方在乙方任职期间，因履行职务或者主要是利用乙方的物质技术条件、业务信息等产生的发明创造、技术秘密或其他商业秘密，有关的知识产权均属于乙方享有。乙方可以在其业务范围内充分自由地利用这些发明创造、技术秘密或其他商业秘密，进行生产、经营或者向第三方转让。甲方应当依乙方的要求，提供一切必要的信息和采取一切必要的行动，包括申请、注册、登记等，协助乙方取得和行使有关的知识产权。
        上述发明创造、技术秘密及其他商业秘密，有关的发明权、署名权（依照法律规定应由乙方署名的除外）等精神权利由作为发明人、创作人或开发者的甲方享有，乙方尊重甲方的精神权利并协助甲方行使这些权利。
      </p>
      <p>
        第二条
        甲方在乙方任职期间所完成的、与乙方业务相关的发明创造、技术秘密或其他商业秘密，甲方主张由其本人享有知识产权的，应当及时向乙方申明。经乙方核实，认为确属于非职务成果的，由甲方享有知识产权，乙方不得在未经甲方明确授权的前提下利用这些成果进行生产、经营，亦不得自行向第三方转让。
        甲方没有申明的，推定其属于职务成果，乙方可以使用这些成果进行生产、经营或者向第三方转让。即使日后证明实际上是非职务成果的，甲方亦不得要求乙方承担任何经济责任。
        甲方申明后，乙方对成果的权属有异议的，可以通过协商解决；协商不成的，通过苏州仲裁委员会仲裁解决。
      </p>
      <p>
        第三条 甲方在乙方任职期间，必须遵守乙方规定的任何成文或不成文的保密规章、制度，履行与其工作岗位相应的保密职责。
        乙方的保密规章、制度没有规定或者规定不明确之处，甲方亦应本着谨慎、诚实的态度，采取任何必要、合理的措施，维护其于任职期间知悉或者持有的任何属于乙方或者虽属于第三方但乙方承诺有保密义务的技术秘密或其他商业秘密信息，以保持其机密性。
      </p>
      <p>
        第四条
        除了履行职务的需要之外，甲方承诺，未经乙方同意，不得以泄露、公布、发布、出版、传授、转让或者其他任何方式使任何第三方（包括按照保密制度的规定不得知悉该项秘密的乙方的其他职员）知悉属于乙方或者虽属于他人但乙方承诺有保密义务的技术秘密或其他商业秘密信息，也不得在履行职务之外使用这些秘密信息。
      </p>
      <p>
        第五条 双方同意，甲方离职之后仍对其在乙方任职期间接触、知悉的属于乙方或者虽属于第三方但乙方承诺有保密义务的技术秘密和其他商业秘密信息，承担如同任职期间一样的保密义务和不擅自使用有关秘密信息的义务，而无论甲方因何种原因离职。
        甲方离职后承担保密义务的期限为自离职之日5年内 。
        甲方认可，乙方在支付甲方的工资报酬时，已考虑了甲方离职后需要承担的保密义务，故而无须在甲方离职时另外支付保密费。
      </p>
      <p>
        第六条 甲方承诺，在为乙方履行职务时，不得擅自使用任何属于他人的技术秘密或其他商业秘密，亦不得擅自实施可能侵犯他人知识产权的行为。
        若甲方违反上述承诺而导致乙方遭受第三方的侵仅指控时，甲方应当承担乙方为应诉而支付的一切费用；乙方因此而承担侵权赔偿责任的，有权向甲方追偿。上述应诉费用和侵权赔偿可以从甲方的工资报酬中扣除。
      </p>
      <p>
        第七条 甲方在履行职务时，按照乙方的明确要求或者为了完成乙方明确交付的具体工作任务必然导致侵犯他人知识产权的，若乙方遭受第三方的侵权指控，应诉费用和侵权赔偿不得由甲方承担或部分承担。
      </p>
      <p>
        第八条 甲方承诺，其在乙方任职期间，非经乙方事先同意，不在与乙方生产、经营同类产品或提供同类服务的其他企业、事业单位、社会团体内担任任何职务，包括但不限于股东、合伙人、董事、监事、经理、代理人、顾问等等。
      </p>
      <p>
        第九条 甲方因职务上的需要所持有或保管的一切记录着乙方秘密信息的文件、资料、图表、笔记、报告、信件、传真、磁带、磁盘、仪器以及其他任何形式的载体，均归乙方所有，而无论这些秘密信息有无商业上的价值。
        若记录着秘密信息的载体是由甲方自备的，则视为甲方已同意将这些载体物的所有权转让给乙方。乙方应当在甲方返还这些载体时，给予甲方相当于载体本身价值的经济补偿。
      </p>
      <p>
        第十条 甲方应当于离职时，或者于乙方提出请求时，返还全部属于乙方的财物，包括记载着乙方秘密信息的一切载体。
        但当记录着秘密信息的栽体是由甲方自备的，且秘密信息可以从载体上消除或复制出来时，可以由乙方将秘密信息复制到乙方享有所有权的其他载体上，并把原载体上的秘密信息消除。此种情况甲方无须将载体返还，乙方也无须给予甲方经济补偿。
      </p>
      <p>
        第十一条
        本合同提及的技术秘密，包括但不限于：技术方案、工程设计、电路设计、制造方法、配方、工艺流程、技术指标、计算机软件、数据库、研究开发记录、技术报告、检测报告、实验数据、试验结果、图纸、样品、样机、模型、模具、操作手册、技术文档、相关的函电，等等。
        本合同提及的其他商业秘密，包括但不限于：客户名单、行销计划、采购资料、定价政策、财务资料、进货渠道，等等。
      </p>
      <p>
        第十二条 本合同中所称的任职期间，以甲方从乙方领取工资为标志，并以该项工资所代表的工作期间为任职期间。
        本合同中所称的离职，以任何一方明确表示解除或辞去聘用关系的时间为准。
        甲方拒绝领取工资且停止履行职务的行为，视为提出辞职。
      </p>
      <p>
        第十三条 因本合同而引起的纠纷，如果协商解决不成，任何一方均有权提交苏州仲裁委员会仲裁。
      </p>
      <p>
        第十四条 甲方如违反本合同任一条款，应当一次性向乙方支付其年收入30倍的违约金 ；无论违约金给付与否，乙方均有权不经预告立即解除与甲方的聘用关系。
        甲方的违约行为给乙方造成损失的，甲方应当赔偿乙方的损失。违约金不能代替赔偿损失，但可以从损失额中抵扣。
      </p>
      <p>
        第十五条 本合同自双方签字或盖章完成之日起生效。
      </p>
      <p>
        第十六条 本合同如与双方以前的口头或书面协议有抵触，以本合同为准。本合同的修改必须采用双方同意的书面形式。
      </p>
      <p class="l3">甲方： <input v-model="form.laborName" name="laborName" class="default" type="text"></p>　　　　　　　　　　　　　　
      <p class="l3">地址： <input class="default" name="laborAddress" v-model="form.laborAddress" type="text"></p>　　　　　　　　
      <p class="l3">身份证号： <input class="default" name="laborIdentityNo" v-model="form.laborIdentityNo" type="text"></p>
      <p class="l3">电话： <input class="default" name="laborTell" v-model="form.laborTell" type="text"></p>　　　　　　　　 　 　
      <p class="l3">时间： <input :value="new Date() | format('YYYY年MM月DD日')" type="text" class="default"/></p>
      <p class="l3">乙方： <input name="companyName" v-model="form.companyName" class="default" type="text"></p>
      　　　　　　　　　　　　　　
      <p class="l3">法定代表： <input name="companyLegal" v-model="form.companyLegal" class="default" type="text"></p>
      　　　　　　　　　　　　
      <p class="l3">地址： <input name="companyAddress" v-model="form.companyAddress" class="default" type="text"></p>
      　　　　　　　　 　 　
      <p class="l3">电话： <input name="companyTell" v-model="form.companyTell" class="default" type="text"></p>　　　　　　　　 　
      　
      <p class="l3">时间： <input :value="new Date() | format('YYYY年MM月DD日')" type="text" class="default"/></p>
      <input type="hidden" value="confidentiality" name="tempType"/>
    </form>
  </div>
</template>

<script>
export default {
  name: "labor",
  data() {
    return {
      form: {
        companyName: '',
        companyLegal: '',
        companyAddress: '',
        companyTell: '',
        laborName: '',
        laborTell: '',
        laborIdentityNo: '',
        laborAddress: '',
      }
    }
  },
  methods: {
    submit: function () {
      // 子组件中触发父组件方法ee并传值cc12345
      //this.$emit('eeb', this.form)
    },
  }
}
</script>

<style lang="less" scoped>
input {
  width: 100px;
  height: 24px;
  line-height: 24px;
  outline: none;
  border: none;
  border-bottom: 1px solid #000;
  padding: 0 6px;
  resize: none;
  overflow: hidden;
  vertical-align: middle;
}

h1 {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 80px;
}

.labor-tpl {
  width: 100%;
  padding-top: 100px;
  padding-bottom: 60px;
  height: auto;
  font-size: 16px;
  font-family: '宋体';

  p.l3 {
    margin: 32px;
    text-indent: 0px;
  }

  .default {
    width: 50% !important;
  }

  p {
    text-indent: 32px;
    line-height: 2;
    margin: 8px 0;
  }
}
</style>



// WEBPACK FOOTER //
// components/sys-contract/confidentiality.vue